import React from 'react';

// Loaded on demand so bundles that only occasionally render the teacher
// sub-header do not ship the ActionCable client and live view store
const StudentsOnlineNavbarButton = React.lazy(() => import('../components/live_view/studentsOnlineNavbarButton'));

const StudentsOnlineNavbarButtonLazyClient = (props) => (
  <React.Suspense fallback={null}>
    <StudentsOnlineNavbarButton {...props} />
  </React.Suspense>
);

export default StudentsOnlineNavbarButtonLazyClient;
